import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Hero from './components/Hero';
import CategoryCards from './components/CategoryCards';
import HotRoutes from './components/HotRoutes';
import FeaturedArticles from './components/FeaturedArticles';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';
import { siteInfo, faqData } from '@/mocks/homeData';

export default function Home() {
  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqData.map((faq) => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer,
      },
    })),
  };

  const websiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: siteInfo.name,
    url: 'https://aiqingdao.com',
    description: siteInfo.description,
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://aiqingdao.com/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  const organizationSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: siteInfo.name,
    url: 'https://aiqingdao.com',
    description: siteInfo.description,
    contactPoint: {
      '@type': 'ContactPoint',
      telephone: siteInfo.phone,
      contactType: 'customer service',
      availableLanguage: 'Chinese',
    },
  };

  const webPageSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: `${siteInfo.name} - ${siteInfo.tagline}`,
    description: siteInfo.description,
    url: 'https://aiqingdao.com/',
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(organizationSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(webPageSchema) }}
      />

      <header>
        <Navbar />
      </header>

      <main>
        <article>
          <Hero />
          <CategoryCards />
          <HotRoutes />
          <CTASection />
          <FeaturedArticles />
          <FAQSection />
        </article>
      </main>

      <Footer />
    </>
  );
}